import { Button } from "@/components/ui";
import { useTranslation } from "@/packages/utils";
import { SettingsSection } from "./SettingsSection";
import { integrations } from "./data";
import type { Integration } from "./types";

export function IntegrationsSection() {
  const { t } = useTranslation(["settings"]);
  return (
    <SettingsSection
      title={t("settings:integrations.title")}
      description={t("settings:integrations.description")}
    >
      <div className="grid grid-cols-2 gap-4">
        {integrations.map((integration) => (
          <IntegrationCard key={integration.id} integration={integration} />
        ))}
      </div>
    </SettingsSection>
  );
}

function IntegrationCard({ integration }: { integration: Integration }) {
  const { t } = useTranslation(["settings"]);
  return (
    <div className="rounded-card border border-border p-5 bg-card flex items-start gap-4 hover:border-border hover:shadow-sm transition-all">
      <div
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-white text-[14px] font-bold"
        style={{ backgroundColor: integration.color }}
      >
        {integration.name.charAt(0)}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <h3 className="text-[14px] font-medium text-primary">
            {integration.name}
          </h3>
          {integration.connected && (
            <span className="flex items-center gap-1 text-[11px] text-accent font-medium">
              <span className="h-1.5 w-1.5 rounded-full bg-accent" />
              {t("settings:integrations.connected")}
            </span>
          )}
        </div>
        <p className="text-[12px] text-secondary mb-3 leading-relaxed">
          {integration.description}
        </p>
        <Button
          variant={integration.connected ? "secondary" : "primary"}
          size="sm"
        >
          {integration.connected
            ? t("settings:integrations.disconnect")
            : t("settings:integrations.connect")}
        </Button>
      </div>
    </div>
  );
}
